import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'one_session_time'

export default function OneSessionTimePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value === 'tenMin' ||
    value === 'twentyMin' ||
    value === 'fortyFiveMin' ||
    value === 'moreThanFortyFiveMin'
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const sex = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question:
        'What is the maximum amount of time you want to train in one session?',
      answer_key: sex.toLowerCase(),
      answer: sex,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.oneSessionTime.heading')}
      buttons={[
        {
          text: t('pages.onboarding.oneSessionTime.options.tenMin'),
          value: 'tenMin',
        },
        {
          text: t('pages.onboarding.oneSessionTime.options.twentyMin'),
          value: 'twentyMin',
        },
        {
          text: t('pages.onboarding.oneSessionTime.options.fortyFiveMin'),
          value: 'fortyFiveMin',
        },
        {
          text: t(
            'pages.onboarding.oneSessionTime.options.moreThanFortyFiveMin',
          ),
          value: 'moreThanFortyFiveMin',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
